import $ from 'jquery';
import { dlPush } from './datalayer';

export default class KetelKiezer {
    constructor(ketelkiezerHolder) {
        if (!ketelkiezerHolder) {
            return;
        }

        this.holder = ketelkiezerHolder;
        this.ketelKiezerOptions = ketelkiezerHolder.querySelector('.ketelkiezer-opties');
        this.toggleKetelkiezerBtn = ketelkiezerHolder.querySelector('.toggle-ketelkiezer');

        if (this.ketelKiezerOptions) {
            this.steps = this.ketelKiezerOptions.querySelector('.steps');
            this.options = this.ketelKiezerOptions.querySelectorAll('.steps input[type="radio"]');
            this.stepNav = this.ketelKiezerOptions.querySelectorAll('.step-nav .step-btn');

            this.currentIndex = 0;

            this.addEvents();
        } else {
            this.holder.querySelectorAll('.selection').forEach((select) => {
                return this.setHiddenField(select);
            });

            this.holder.querySelectorAll('.selection').forEach((select) => {
                return select.addEventListener('change', () => {
                    return this.setHiddenField(select);
                });
            });
        }

        if (this.holder.dataset.load) {
            // Tracken dat de ketelkiezer geopend is bij het laden van de pagina, door een directe link
            this.dlEvent(true);
            this.toggleKetelkiezer();
        }
    }

    dlEvent(auto = false) {
        if (this.index === this.stepNav.length) {
            dlPush({ event: 'conversion', conversionType: 'ketelkiezer_voltooid' });
            return;
        }
        dlPush({ event: 'ketelkiezer', step: this.currentIndex + 1, auto });
    }

    addEvents() {
        // Toggle ketelkiezer
        this.toggleKetelkiezerBtn.addEventListener('click', () => {
            // Track alleen gevallen waar de kiezer actief geopend wordt met de knop
            this.dlEvent();
            return this.toggleKetelkiezer();
        });

        // Step navigation
        this.stepNav.forEach((btn) => {
            return btn.addEventListener('change', () => {
                return this.setStep(btn.value);
            });
        });

        // Options
        this.options.forEach((option) => {
            option.checked = false;
            option.addEventListener('change', (evt) => {
                return this.toggleOption(evt.currentTarget);
            });
        });
    }

    disableInputs() {
        this.options.forEach((option) => {
            return option.disabled = true;
        });
    }

    enableInputs() {
        this.options.forEach((option) => {
            return option.disabled = false;
        });
    }

    setStep(index) {
        this.currentIndex = parseInt(index);
    }

    setStepNav() {
        this.stepNav.forEach((btn) => {
            return this.currentIndex == btn.value ? btn.checked = true : btn.checked = false;
        });
    }

    toggleKetelkiezer() {
        this.holder.classList.toggle('active');
        $(this.ketelKiezerOptions).slideToggle();
    }

    toggleOption(option) {
        this.disableInputs();
        this.setHiddenField(option);
        window.setTimeout(() => {
            return this.currentIndex += 1;
        }, 400);
    }

    setStepsPosition() {
        var currentPos = this.currentIndex * 33.33;
        this.steps.style.transform = 'translateX(-' + currentPos + '%)';
    }

    setHiddenField(option) {
        var sName = 'w-' + option.dataset.name;
        var sValue = option.value;

        document.querySelector('input[name="' + sName + '"]').value = sValue;
    }

    get currentIndex() {
        return this.index;
    }

    set currentIndex(index) {
        this.enableInputs();
        this.index = index;
        // Index wordt op 0 gezet bij het initialiseren, dus alleen pushen bij hogere stappen
        if (index > 0) {
            this.dlEvent();
        }
        if (this.stepNav.length === index) {
            this.ketelKiezerOptions.submit();
        } else {
            this.setStepsPosition();
            this.setStepNav();
        }
    }
}